const heroType = [
    'sword',
    'arrow',
    'assassin',
    'magic',
    'heal',
    'fist',
    'spear',
    'spilit',
]

module.exports = heroType;